/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import moment from "moment";
import React, { useState } from "react";
import { MessageList } from "react-chat-elements";
import "react-chat-elements/dist/main.css";
import "./chat.css";
import { PaperAirplaneIcon } from "@heroicons/react/24/solid";
import { PaperClipIcon } from "@heroicons/react/24/outline";

moment.locale("fr");

const ChatRoom = () => {
  const [messageBody, setMessageBody] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!messageBody.trim()) return;
    setMessageBody("");
  };

  return (
    <div className="chat-room h-100 d-inline-block w-100">
      <div className="message-container h-100">
        <MessageList
          className="message-list"
          lockable={true}
          toBottomHeight={"100%"}
          dataSource={[
            {
              position: "left",
              type: "text",
              title: "Kursat",
              text: "Give me a message list example !",
            },
            {
              position: "right",
              type: "text",
              title: "Emre",
              text: "That's all.",
            },
            {
              position: "left",
              type: "text",
              title: "Kursat",
              text: "Give me a message list example !",
            },
            {
              position: "right",
              type: "text",
              title: "Emre",
              text: "That's all.",
            },
          ]}
        />
      </div>
      <div className="chat-composer-wrap">
        <form
          aria-label="Chat bericht opstellen"
          className="chat-composer-shell"
          onSubmit={handleSubmit}
        >
          <button
            type="button"
            className="chat-composer-attach"
            aria-label="Bijlage toevoegen"
          >
            <PaperClipIcon className="h-5 w-5" aria-hidden="true" />
          </button>
          <div className="chat-composer-field">
            <label htmlFor="chat-message-body" className="sr-only">
              Schrijf naar onze support
            </label>
            <textarea
              id="chat-message-body"
              name="body"
              rows={1}
              value={messageBody}
              onChange={(event) => setMessageBody(event.target.value)}
              placeholder="Typ een bericht..."
              className="chat-composer-input"
            />
          </div>
          <button
            type="submit"
            className="chat-composer-send"
            aria-label="Versturen"
          >
            <PaperAirplaneIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatRoom;
